import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/** Keep creation beside the navigation of the surface that opened it. */
export function useCreationSurface() {
  const { pathname } = useLocation();
  const workspace = pathname.includes('/workspace') || pathname.startsWith('/dashboard');
  const [inset, setInset] = useState({ left: 0, top: 86, bottom: 0 });
  useLayoutEffect(() => {
    const measure = () => {
      const mobile = window.innerWidth < 768;
      const sidebar = document.querySelector<HTMLElement>(workspace ? '[data-workspace-sidebar]' : '.ws-store-sidebar');
      const header = workspace ? document.querySelector<HTMLElement>('[data-workspace-header]') : null;
      const sidebarBounds = sidebar?.getBoundingClientRect();
      const headerBounds = header?.getBoundingClientRect();
      setInset({
        left: sidebarBounds && sidebarBounds.height > window.innerHeight / 2 ? sidebarBounds.right : 0,
        top: headerBounds?.height ? Math.max(headerBounds.bottom, 0) : workspace ? 0 : 86,
        bottom: workspace ? window.innerWidth < 1024 ? 88 : 0 : mobile ? Math.max(76, sidebarBounds ? window.innerHeight - sidebarBounds.top + 6 : 76) : 0,
      });
    };
    measure();
    const observer = new ResizeObserver(measure);
    for (const el of document.querySelectorAll('[data-workspace-sidebar], [data-workspace-header], .ws-store-sidebar')) observer.observe(el);
    window.addEventListener('resize', measure);
    return () => { observer.disconnect(); window.removeEventListener('resize', measure); };
  }, [workspace]);
  return { ...inset, workspace };
}
